import { prototypePages } from "@utils/prototypePages"
import { normalizeInternalHrefsInHtml } from "@utils/internalHref"

const getStyleBlocks = head => {
  const matches = [...(head || "").matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi)]
  return matches.map(match => match[1]).join("\n")
}

const getStylesheetLinks = head => {
  const matches = [
    ...(head || "").matchAll(
      /<link\b[^>]*rel=["']stylesheet["'][^>]*href=["']([^"']+)["'][^>]*>/gi
    ),
  ]

  return [...new Set(matches.map(match => match[1]).filter(Boolean))]
}

const stripLeadingChrome = body =>
  (body || "").replace(/^[\s\S]*?<\/nav>\s*/i, "")

const stripTrailingChrome = body => {
  const footerIndex = body.search(/<div id="mc-footer"><\/div>|<!-- FOOTER -->/i)
  return footerIndex === -1 ? body : body.slice(0, footerIndex)
}

const stripFirstSection = body =>
  body.replace(/^(?:\s|<!--[\s\S]*?-->)*<section\b[\s\S]*?<\/section>\s*/i, "")

// The prototype bodies are hand-authored HTML carrying inline links written in the
// no-slash form (`<a href="/how-it-works">`). They render straight through
// dangerouslySetInnerHTML on 17 pages, so canonicalising here is what keeps those
// links from costing a 301 — see @utils/internalHref.
const normalizeHtml = html => normalizeInternalHrefsInHtml(html.trim())

export const getPrototypePageSlice = pageKey => {
  const page = prototypePages[pageKey]

  if (!page) {
    return {
      extraStyles: "",
      extraHeadLinks: [],
      contentHtml: "",
    }
  }

  const contentHtml = normalizeHtml(
    stripTrailingChrome(stripFirstSection(stripLeadingChrome(page.body || "")))
  )

  return {
    extraStyles: [getStyleBlocks(page.head || ""), getStyleBlocks(page.body || "")]
      .filter(Boolean)
      .join("\n"),
    extraHeadLinks: getStylesheetLinks(page.head || ""),
    contentHtml,
  }
}

export const getPrototypeRuntimeHtml = pageKey => {
  const page = prototypePages[pageKey]

  if (!page) return ""

  const body = page.body || ""
  const footerIndex = body.search(/<div id="mc-footer"><\/div>|<!-- FOOTER -->/i)
  return normalizeHtml(footerIndex === -1 ? body : body.slice(footerIndex))
}

export default getPrototypePageSlice
